import { useSetRecoilState } from 'recoil';

import { defined } from '../../../utils/defined';
import { profileIdState } from '../../atoms';
import { useAuthenticatedQuery } from '../../graphql';

export const useLoadSession = (): void => {
	const setProfileId = useSetRecoilState(profileIdState);

	useAuthenticatedQuery({
		onCompleted({ session: { authenticated, profile } }) {
			if (!authenticated || !defined(profile)) {
				setProfileId(undefined);
			}

			if (defined(profile)) {
				setProfileId(profile.id);
			}
		}
	});
};
